// Port of api/fuel/app/classes/filter/search/games/rules/query/language_independance.php
import Rule from 'offline/filter/core/search/rule'

function mapValue(rule, name) {
	name = name || 'value'
	var value = rule.logic && rule.logic[name]
	if (Array.isArray(value)) value = value[0]

	if (value === 'none') return 5
	if (value === 'little') return 4
	if (value === 'moderate') return 3
	if (value === 'alot') return 2
	if (value === 'all') return 1
	return 0
}

export default Rule.create({
	name: 'language_independance',
	field: function() { return 'g.game_language_dependency' },
	value: function(rule, name) { return mapValue(rule, name) },
	// Language dependency is inverted: lower number = more dependent.
	// So "min independence" means "max dependency number" and vice versa.
	min: function(rule, config, filter, data, query) {
		var opMap = Rule.operandMapped(rule, { '>=': '<=', '>': '<' })
		query.where(this.field(), opMap, mapValue(rule))
	},
	max: function(rule, config, filter, data, query) {
		var opMap = Rule.operandMapped(rule, { '<=': '>=', '<': '>' })
		query.where(this.field(), opMap, mapValue(rule))
	}
})
